import React from 'react'

function SalesView() {
    return (
        <div>SalesView</div>
    )
}

export default SalesView